<template>
  <v-container>
    <v-layout row wrap>
      <HesloDialog v-if="vyzadovana_zmena_hesla" v-model="vyzadovana_zmena_hesla" :close="true" :stare_heslo="true"></HesloDialog>
      <v-dialog
        v-model="dialogUdaje"
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogUdaje"
        persistent
      >
        <v-card class="no__padding">
          <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
            <h2>Žádost o změnu osobních údajů</h2>
          </v-card-title>
          <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}" v-if="!requestSent">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="[{value: 'po', text: 'Právnická osoba'}, {value: 'fo', text: 'Fyzická osoba'}, {value: 'osvc', text: 'OSVČ'}]"
                    v-model="edit_mode_udaje.typ_osoby"
                    label="Typ osoby"
                    item-value="value"
                    item-text="text"
                    class="mx-2"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-flex xs12 v-if="edit_mode_udaje.typ_osoby=='po' || edit_mode_udaje.typ_osoby=='osvc'">
                    <v-text-field :label="edit_mode_udaje.typ_osoby=='po' ? 'Název firmy' : 'Název osoby'" v-model="edit_mode_udaje.nazev_firmy" class="mx-2"></v-text-field>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field label="IČ" class="mx-2" v-model="edit_mode_udaje.ic" v-if="edit_mode_udaje.typ_osoby=='po' || edit_mode_udaje.typ_osoby=='osvc'"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field label="DIČ" class="mx-2" v-model="edit_mode_udaje.dic" v-if="edit_mode_udaje.typ_osoby=='po' || edit_mode_udaje.typ_osoby=='osvc'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field label="Jméno" class="mx-2" v-model="edit_mode_udaje.jmeno"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field label="Příjmení" class="mx-2" v-model="edit_mode_udaje.prijmeni"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <datepicker label="Datum narození" class="mx-2" v-model="edit_mode_udaje.datum_narozeni"></datepicker>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <kraje label="Kraj" class="mx-2" v-model="edit_mode_udaje.kraj_id" :rules="rulesRequired"></kraje>
                </v-flex>
                <v-flex xs12 sm6 md8>
                  <zpusoby-doruceni label="Způsob doručení" class="mx-0" v-model="edit_mode_udaje.zpusob_doruceni_id" :rules="rulesRequired"></zpusoby-doruceni>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field label="Telefon" type="tel" class="mx-2" v-model="edit_mode_udaje.telefon" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md8>
                  <v-text-field label="Email" type="email" class="mx-2" v-model="edit_mode_udaje.email" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}" v-else>
            <p class="text-xs-center bold ma-4 green--text">Vaše žádost byla přijata.</p>
          </v-card-text>
          <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
            <v-spacer></v-spacer>
            <v-btn color="orange elevation-0" class="bold" dark @click="edit" :loading="saving" v-if="!requestSent">Odeslat žádost</v-btn>
            <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogUdaje=false" v-if="!saving">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogUdajeClient"
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogUdajeClient"
      >
        <v-card class="no__padding">
          <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
            <h2>Změna osobních údajů</h2>
          </v-card-title>
          <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <h4 class="mb-2">Žádám o změnu údajů:</h4>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Uveďte údaje, které chcete změnit" type="text" class="mx-2" textarea :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
            <v-spacer></v-spacer>
            <v-btn color="orange elevation-0" class="bold" dark @click="edit" :loading="saving">Odeslat žádost</v-btn>
            <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogUdajeClient=false" v-if="!saving">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="editAddressDialog"
        persistent
        max-width="800px"
        transition="dialog-transition"
        v-if="editAddressDialog"
      >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2><span v-if="newAddress">Nová adresa</span><span v-else>Upravit adresu</span></h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-checkbox label="Hlavní adresa" v-model="updateAdressItem.hlavni" class="mx-2"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox v-if="!updateAdressItem.hlavni" label="Fakturační adresa" v-model="updateAdressItem.fakturacni" class="mx-2"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox v-if="!updateAdressItem.hlavni" label="Doručovací adresa" v-model="updateAdressItem.dorucovaci" class="mx-2"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                :items="[{value: 'po', text: 'Právnická osoba'}, {value: 'fo', text: 'Fyzická osoba'}, {value: 'osvc', text: 'OSVČ'}]"
                v-model="updateAdressItem.typ_osoby"
                label="Typ osoby"
                item-value="value"
                item-text="text"
                class="mx-2"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="updateAdressItem.typ_osoby=='po' || updateAdressItem.typ_osoby=='osvc'">
            <v-flex xs12 sm7>
              <v-layout row wrap>
                <v-flex grow>
                  <v-text-field label="IČ" v-model="updateAdressItem.ic" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex align-self-end shrink>
                  <v-btn color="primary" flat align-baseline class="mb-3 mr-3" @click="loadAres"><v-icon small class="mr-2" :class="{'spin': loadingAres}">sync</v-icon>Načíst z ARES</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm5>
              <v-text-field label="DIČ" v-model="updateAdressItem.dic" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex xs12 v-if="updateAdressItem.typ_osoby=='po'">
                <v-text-field label="Název firmy" v-model="updateAdressItem.nazev_firmy" class="mx-2"></v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field label="Jméno" v-model="updateAdressItem.jmeno" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field label="Příjmení" v-model="updateAdressItem.prijmeni" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm5>
              <v-text-field label="Ulice" v-model="updateAdressItem.ulice" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm5>
              <v-text-field label="Město" v-model="updateAdressItem.mesto" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field label="PSČ" v-model="updateAdressItem.psc" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm5>
              <v-text-field label="Telefon" v-model="updateAdressItem.telefon" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="orange elevation-0" class="bold" v-if="newAddress" dark @click="addAddress" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="orange elevation-0" class="bold" v-else dark @click="editAddress" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" class="bold" @click="editAddressDialog=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeAddressDialog"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="removeAddressDialog"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2>Smazat adresu</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          Opravu chcete smazat tuto adresu <strong>{{removeAddressItem.cela_adresa}}</strong>?
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" class="bold" dark @click="removeAddress" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" class="bold" @click="removeAddressDialog=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editBankUcetDialog"
      persistent
      max-width="800px"
      transition="dialog-transition"
      v-if="editBankUcetDialog"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2><span>Nový bankovní účet</span></h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <!-- <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-select
                :items="typy_bank_uctu"
                v-model="updateBankUcet.typ_uctu"
                label="Typ bankovního účtu"
                item-value="typ_uctu"
                item-text="nazev"
                class="mx-2"
              ></v-select>
            </v-flex>
          </v-layout> -->
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-text-field
                label="Účet"
                v-model="updateBankUcet.ucet"
                class="mx-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 v-if="updateBankUcet.typ_uctu=='cz'">
              <v-text-field
                label="Kód banky"
                v-model="updateBankUcet.ucet_kod_banky"
                class="mx-2"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="orange elevation-0" class="bold" dark @click="createBankUcet" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" class="bold" @click="editBankUcetDialog=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeBankUcetDialog"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="removeBankUcetDialog"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2>Smazat bankovní účet</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          Opravu chcete smazat tento bankovní účet <strong>{{removeBankUcetItem.ucet}} / {{removeBankUcetItem.ucet_kod_banky}}</strong>?
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" class="bold" dark @click="removeBankUcet" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" class="bold" @click="removeBankUcetDialog=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <!-- <Loader v-if="loading" skin="light"></Loader> -->
      <v-flex xs12 v-if="!loading">
        <div class="account" :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap align-center class="mb-30">
            <v-flex xs12 sm3>
              <h1 class="h2">Osobní údaje</h1>
            </v-flex>
            <v-flex xs12 sm9>
              <div class="text-xs-left text-sm-right">
                <!-- <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20" @click="editClickClient" v-if="!me.spolupracovnik">Zažádat o&nbsp;změnu osobních údajů</v-btn>
                <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20" @click="editClick" v-if="me.spolupracovnik">Změnit údaje</v-btn> -->
                <v-btn color="orange" dark class="elevation-0 ma-0 mr-2 bold mt-xs-20" @click="vyzadovana_zmena_hesla=true">Změnit heslo</v-btn>
                <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20" @click="editClick">Zažádat o&nbsp;změnu osobních údajů</v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3>
              <v-layout row wrap>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold" v-if="moje_udaje.typ_osoby=='fo'">Jméno a příjmení:</p>
                  <p class="grey--text caption mb-1 bold" v-else-if="moje_udaje.typ_osoby=='osvc'">Název osoby</p>
                  <p class="grey--text caption mb-1 bold" v-else>Název firmy</p>
                  <strong>{{moje_udaje.nazev_osoby}}</strong>
                </v-flex>
                <v-flex xs12 class="mb-20" v-if="moje_udaje.typ_osoby=='fo' || moje_udaje.typ_osoby=='osvc'">
                  <p class="grey--text caption mb-1 bold" v-if="moje_udaje.datum_narozeni">Datum narození:</p>
                  <strong>{{moje_udaje.datum_narozeni | formatSimpleDate}}</strong>
                </v-flex>
                <v-flex xs12 class="mb-20" v-if="moje_udaje.typ_osoby!='fo'">
                  <p class="grey--text caption mb-1 bold">IČ:</p>
                  <strong v-if="moje_udaje.ic">{{moje_udaje.ic}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20" v-if="moje_udaje.typ_osoby!='fo'">
                  <p class="grey--text caption mb-1 bold">DIČ:</p>
                  <strong v-if="moje_udaje.dic">{{moje_udaje.dic}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Způsob doručení:</p>
                  <strong v-if="moje_udaje.zpusob_doruceni">{{moje_udaje.zpusob_doruceni.nazev}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-layout row wrap>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Telefon:</p>
                  <strong v-if="moje_udaje.telefon">{{moje_udaje.telefon}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20" v-if="moje_udaje.typ_osoby=='po'">
                  <p class="grey--text caption mb-1 bold">Jméno jednatele:</p>
                  <strong v-if="moje_udaje.jmeno && moje_udaje.prijmeni">{{moje_udaje.jmeno}} {{moje_udaje.prijmeni}}</strong>
                  <strong v-else-if="moje_udaje.jmeno">{{moje_udaje.jmeno}}</strong>
                  <strong v-else-if="moje_udaje.prijmeni">{{moje_udaje.prijmeni}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">E-mail:</p>
                  <strong v-if="moje_udaje.email">{{moje_udaje.email}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text mb-1 caption bold">Číslo účtu:</p>
                  <div class="mt-1" v-if="moje_udaje.bankovni_ucty != null && moje_udaje.bankovni_ucty.length > 0">
                    <div v-for="bankovni_ucet in moje_udaje.bankovni_ucty">
                      <strong v-if="bankovni_ucet.ucet">{{bankovni_ucet.ucet}}/{{bankovni_ucet.ucet_kod_banky}}</strong>
                      <strong v-else>--</strong>
                    </div>
                  </div>
                  <div v-else>
                    <strong>--</strong>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="me.spolupracovnik && !me.makler && !me.podrizeny_maklere">
              <v-layout row wrap>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Certifikován:</p>
                  <v-icon class="text-green" style="margin-bottom: 2px;" small v-if="moje_udaje.certifikovan">check_circle_outline</v-icon>
                  <v-icon class="text-red" style="margin-bottom: 2px;" small v-else>highlight_off</v-icon>
                  <strong v-if="moje_udaje.certifikovan" class="ml-2">ANO</strong>
                  <strong v-else class="ml-2">NE</strong>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- <v-flex xs12 sm6 md3>
              <v-layout row wrap v-for="adresa in moje_udaje.adresy">
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Ulice a č.p.:</p>
                  <strong v-if="adresa.ulice">{{adresa.ulice}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">PSČ:</p>
                  <strong v-if="adresa.psc">{{adresa.psc}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Obec:</p>
                  <strong v-if="adresa.mesto">{{adresa.mesto}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
              </v-layout>
            </v-flex> -->

          </v-layout>

          <!-- TODO pokud bude adresa odlišná od hlavní adresy -->
          <!-- <v-flex xs12 sm6>
            <div class="text-xs-left text-sm-right">
              <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20">Změnit adresu</v-btn>
            </div>
          </v-flex> -->


          <!-- <hr class="account__hr">
          <div v-for="adresa in moje_udaje.adresy">
            <v-layout row wrap align-center class="mb-30">
              <v-flex xs12 sm6>
                <h2 v-if="adresa.hlavni">Hlavní adresa</h2>
                <h2 v-else-if="fakruracni.hlavni">Fakturační adresa</h2>
                <h2 v-else>Doručovací adresa</h2>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">Jméno a příjmení:</p>
                <strong v-if="adresa.typ_osoby == 'fo'">{{adresa.jmeno}} {{adresa.prijmeni}}</strong>
                <strong v-else-if="adresa.typ_osoby == 'osvc' || adresa.typ_osoby == 'po'">{{adresa.nazev_firmy}}</strong>
                <strong v-else>--</strong>
              </v-flex>
              <v-flex v-if="adresa.ic" xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">IČ:</p>
                <strong>{{adresa.ic}}</strong>
              </v-flex>
              <v-flex v-if="adresa.dic" xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">DIČ:</p>
                <strong>{{adresa.dic}}</strong>
              </v-flex>
              <v-flex xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">Ulice a č.p.:</p>
                <strong v-if="adresa.ulice">{{adresa.ulice}}</strong>
                <strong v-else>--</strong>
              </v-flex>
              <v-flex xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">PSČ:</p>
                <strong v-if="adresa.psc">{{adresa.psc}}</strong>
                <strong v-else>--</strong>
              </v-flex>
              <v-flex xs12 sm6 md3 class="mb-20">
                <p class="grey--text caption mb-1 bold">Obec:</p>
                <strong v-if="adresa.mesto">{{adresa.mesto}}</strong>
                <strong v-else>--</strong>
              </v-flex>
            </v-layout>
            <hr class="account__hr">
          </div> -->

          <v-layout row wrap class="mt-3">
            <v-flex grow>
              <h3>Adresy</h3>
            </v-flex>
            <v-flex shrink v-if="!testovaci_klient">
              <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20" @click="addAddressClick">Přidat adresu</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-0">
                <v-data-table
                  :headers="headersAdresy"
                  :items="moje_udaje.adresy"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.hlavni">Hlavní</div>
                      <div v-if="props.item.fakturacni">Fakturační</div>
                      <div v-if="props.item.dorucovaci">Doručovací</div>
                    </td>
                    <td>{{ props.item.jmeno }} {{ props.item.prijmeni }}</td>
                    <td>{{ props.item.nazev_firmy }}</td>
                    <td>{{ props.item.cela_adresa }}</td>
                    <td>{{ props.item.ic }}</td>
                    <td>{{ props.item.dic }}</td>
                    <td>{{ props.item.telefon }}</td>
                    <td class="text-xs-right">
                      <v-btn color="primary" @click="editAddressClick(props.item)" flat class="mr-1" v-if="!testovaci_klient"><v-icon class="mr-2">edit</v-icon> Upravit</v-btn>
                      <v-btn color="red" flat icon small class="mr-0" @click="removeAddressClick(props.item)" v-if="!testovaci_klient"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="mt-5">
            <v-flex grow>
              <h3>Bankovní účty</h3>
            </v-flex>
            <v-flex shrink v-if="!testovaci_klient">
              <v-btn color="orange" dark class="elevation-0 ma-0 bold mt-xs-20" @click="createBankUcetClick">Přidat bankovní účet</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-0">
                <v-data-table
                  :headers="headersBankUcty"
                  :items="moje_udaje.bankovni_ucty"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.typ_uctu=='iban'">IBAN</div>
                      <div v-if="props.item.typ_uctu=='cz'">Český účet</div>
                    </td>
                    <td>
                      <span v-if="props.item.typ_uctu=='iban'">{{ props.item.ucet }}</span>
                      <span v-if="props.item.typ_uctu=='cz'">{{ props.item.ucet }}/{{ props.item.ucet_kod_banky }}</span>
                    </td>
                    <td class="text-xs-right">
                      <v-btn color="red" flat icon small class="mr-0" @click="removeBankUcetClick(props.item)" v-if="!testovaci_klient"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap align-center class="mb-30 mt-5" v-if="me.spolupracovnik">
            <v-flex xs12 sm6>
              <h2>Dokumenty</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="me.spolupracovnik">
            <v-flex xs12>
              <div v-if="moje_udaje.dokumenty.length > 0">
                <template v-for="d in moje_udaje.dokumenty">
                  <a :href="'https://uw-comfort-com-images.s3.eu-west-1.amazonaws.com/'+d.s3_nazev" target="_blank" class="tm1 white--text"><v-btn color="orange" dark class="elevation-0 ma-0 mb-20 bold account-doc"><v-icon class="mr-2">save_alt</v-icon> {{d.dokument_nazev}}</v-btn></a>
                </template>
              </div>
              <div v-else>
                <p class="bold mt-0 pt-0">Zatím nebyly nahrány žádné dokumenty.</p>
              </div>
            </v-flex>
          </v-layout>
          <hr class="account__hr">
          <div class="account__person">
            <v-layout row wrap align-start>
              <v-flex xs12>
                <v-layout row wrap align-center>
                  <v-flex sm6 v-if="moje_udaje.poradce != null">
                    <h4 class="mb-2">Vaším poradcem je:</h4>
                    <v-layout row wrap>
                      <!-- <v-flex sm4>
                        <img src="" alt="Profil poradce">
                      </v-flex> -->
                      <v-flex sm12>
                        <h3 class="h2 text-primary mb-2">{{moje_udaje.poradce.nazev_osoby}}</h3>
                        <!-- <h4 class="mb-2">{{moje_udaje.poradce.nazev_osoby}}</h4> -->
                        <p class="bold mb-1">Telefon: <a class="link-black" :href="'tel:'+moje_udaje.poradce.telefon">{{moje_udaje.poradce.telefon}}</a></p>
                        <p class="bold mb-1">Email: <a class="link-black" :href="'mailto:'+moje_udaje.poradce.email">{{moje_udaje.poradce.email}}</a></p>
                        <p class="text-gray bold mb-0 fs-14">Pro změnu údajů kontaktujte svého poradce.</p>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="!me.spolupracovnik && moje_udaje.poradce_id == 1">
                      <v-flex xs12>
                        <v-dialog v-model="dialogPoradce" :persistent="savingPoradce" max-width="590">
                          <template v-slot:activator="{ on }">
                            <v-btn color="orange" class="ma-0 mt-2" depressed dark v-on="on"><strong>Chci požádat o osobního poradce</strong></v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="headline">Žádost o osobního poradce</v-card-title>
                            <v-card-text v-if="poradceZazadan">Vaše žádost o osobního poradce byla odeslána.</v-card-text>
                            <v-card-text v-else>Prosím potvrďte Vaši žádost o osobního poradce.</v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="orange" depressed dark @click="zadostOsobniPoradce" :loading="savingPoradce" v-if="!poradceZazadan">Ano, žádám o osobního poradce</v-btn>
                              <v-btn color="grey lighten-3" depressed @click="dialogPoradce = false" v-if="!savingPoradce">Zavřít</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex sm6 :class="{'mt-4': $vuetify.breakpoint.xs}">
                    <h4 class="mb-2">Kontakt na centrálu:</h4>
                    <h3 class="h2 text-primary mb-2"><span class="text-uppercase">Comfort Commodity</span> a.s.</h3>
                    <p class="bold mb-1">
                      <a class="link-black" href="https://goo.gl/maps/RpKsoS2o429iNJoz9" target="_blank">Plaská 2119/54a, 323 00 Plzeň</a>
                    </p>
                    <p class="bold mb-1">Telefon: <a class="link-black" :href="'tel:+420734232022'">+420 734 232 022</a></p>
                    <p class="bold mb-1">Email: <a class="link-black" :href="'mailto:info@comfort-commodity.cz'">info@comfort-commodity.cz</a></p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  import HesloDialog from '@/components/HesloDialog'
  export default {
    extends: Base,
    data () {
      return {
        valid: true,
        loading: true,
        dialogUdaje: false,
        dialogUdajeClient: false,
        items: [
          'Ano',
          'Ne'
        ],
        rulesRequired: [
          (v) => !!v || "Pole je vyžadováno"
        ],
        moje_udaje: {},
        edit_mode_udaje: null,
        saving: false,
        headersAdresy: [
          { text: 'Typ adresy', value: 'id', sortable: false },
          { text: 'Jméno a příjmeni', value: 'nazev_osoby', sortable: false },
          { text: 'Název firmy', value: 'nazev_firmy', sortable: false },
          { text: 'Adresa', value: 'cela_adresa', sortable: false },
          { text: 'IČ', value: 'ic', sortable: false },
          { text: 'DIČ', value: 'dic', sortable: false },
          { text: 'Telefon', value: 'telefon', sortable: false },
          { text: 'Akce', value: null, sortable: false, align: "right" }
        ],
        headersBankUcty: [
          { text: 'Typ účtu', value: 'typ_uctu', sortable: false },
          { text: 'Účet', value: 'ucet', sortable: false },
          { text: 'Akce', value: null, sortable: false, align: "right" }
        ],
        editAddressDialog: false,
        newAddress: false,
        updateAdressItem: null,
        sending: false,
        dialogAddressItem: { id: null, typ_osoby: 'fo', jmeno: null, prijmeni: null, nazev_firmy: null, ic: null, dic: null, cela_adresa: null, ulice: null, mesto: null, psc: null, telefon: null, hlavni: false, fakturacni: false, dorucovaci: false },
        removeAddressItem: null,
        removeAddressDialog: false,
        removing: false,
        dialogBankUcet: { id: null, typ_uctu: 'cz', ucet: null, ucet_kod_banky: null },
        typy_bank_uctu: [
          { typ_uctu: 'cz', nazev: 'Čeký účet' },
          // { typ_uctu: 'iban', nazev: 'IBAN' }
        ],
        removeBankUcetItem: null,
        removeBankUcetDialog: false,
        updateBankUcet: null,
        editBankUcetDialog: false,
        requestSent: false,
        dialogHeslo: false,
        show1: false,
        show2: false,
        show3: false,
        vyzadovana_zmena_hesla: false,
        dialogPoradce: false,
        savingPoradce: false
      }
    },
    computed: {
      me () {
        return window.$me;
      },
      testovaci_klient () {
        return window.testovaci_klient;
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        window.API.get("uzivatel/moje-udaje").then(function(body) {
            this.moje_udaje = body;
            this.loading = false;
            if (typeof f == "function")
              f();
        }.bind(this)).catch(function(err) {
            console.log(err);
        }.bind(this));
      },
      editClick () {
        this.edit_mode_udaje = window.th.copy(this.moje_udaje);
        this.edit_mode_udaje.zpusob_doruceni_id = this.edit_mode_udaje.zpusob_doruceni != null ? this.edit_mode_udaje.zpusob_doruceni.id : null;
        this.edit_mode_udaje.kraj_id = this.edit_mode_udaje.kraj != null ? this.edit_mode_udaje.kraj.id : null;
        this.requestSent = false;
        this.dialogUdaje = true;
      },
      editClickClient () {
        // this.edit_mode_udaje = window.th.copy(this.moje_udaje);
        // this.edit_mode_udaje.zpusob_doruceni_id = this.edit_mode_udaje.zpusob_doruceni != null ? this.edit_mode_udaje.zpusob_doruceni.id : null;
        // this.edit_mode_udaje.kraj_id = this.edit_mode_udaje.kraj != null ? this.edit_mode_udaje.kraj.id : null;
        this.requestSent = false;
        this.dialogUdajeClient = true;
      },
      edit () {
        if (this.$refs.createForm.validate()) {
          if (window.testovaci_klient) {
            this.saving = false;
            this.requestSent = true;
          }
          else {
            this.saving = true;
            window.API.put("uzivatel/moje-udaje", {
              typ_osoby: this.edit_mode_udaje.typ_osoby,
              nazev_firmy: this.edit_mode_udaje.nazev_firmy,
              jmeno: this.edit_mode_udaje.jmeno,
              prijmeni: this.edit_mode_udaje.prijmeni,
              titul_pred: this.edit_mode_udaje.titul_pred,
              titul_za: this.edit_mode_udaje.titul_za,
              email: this.edit_mode_udaje.email,
              ic: this.edit_mode_udaje.ic,
              dic: this.edit_mode_udaje.dic,
              datum_narozeni: this.edit_mode_udaje.datum_narozeni,
              kraj: this.edit_mode_udaje.kraj_id,
              zpusob_doruceni: this.edit_mode_udaje.zpusob_doruceni_id,
              telefon: this.edit_mode_udaje.telefon
            }).then(function(body) {
                if (body.updated) {
                  this.load(() => {
                    this.saving = false;
                    this.requestSent = true;
                    //this.dialogUdaje = false;
                  });
                }
                else {
                  this.saving = false;
                }
            }.bind(this)).catch(function(err) {
                this.saving = false;
                console.log(err);
            }.bind(this));
          }
        }
      },
      addAddressClick () {
        this.updateAdressItem = window.th.copy(this.dialogAddressItem);
        this.newAddress = true;
        this.editAddressDialog = true;
      },
      addAddress () {
        this.sending = true;
        window.api.post("uzivatel/adresy", this.updateAdressItem).then((_body) => {
          if (_body.inserted) {
            this.load(() => {
              this.sending = false;
              this.editAddressDialog = false;
            });
          }
          else {
            this.sending = false;
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false;
        });
      },
      editAddressClick (v) {
        this.updateAdressItem = window.th.copy(v);
        this.newAddress = false;
        this.editAddressDialog = true;
      },
      editAddress () {
        this.sending = true;
        window.api.put("uzivatel/adresy/" + this.updateAdressItem.id, this.updateAdressItem).then((_body) => {
          if (_body.updated) {
            this.load(() => {
              this.sending = false;
              this.editAddressDialog = false;
            });
          }
          else {
            this.sending = false;
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false;
        });
      },
      removeAddressClick  (item) {
        this.removeAddressItem = item;
        this.removeAddressDialog = true;
      },
      removeAddress () {
        this.removing = true;
        window.api.delete("uzivatel/adresy/" + this.removeAddressItem.id).then((_body) => {
          if (_body.deleted) {
            this.load(() => {
              this.removing = false;
              this.removeAddressDialog = false;
            });
          }
          else {
            this.removing = false;
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false;
        });
      },
      createBankUcetClick () {
        this.updateBankUcet = window.th.copy(this.dialogBankUcet);
        this.editBankUcetDialog = true;
      },
      createBankUcet () {
        this.sending = true;
        window.api.post("uzivatel/bankovni-ucty", this.updateBankUcet).then((_body) => {
          if (_body.inserted) {
            this.load(() => {
              this.sending = false;
              this.editBankUcetDialog = false;
            });
          }
          else {
            this.sending = false;
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false;
        });
      },
      removeBankUcetClick (item) {
        this.removeBankUcetItem = item;
        this.removeBankUcetDialog = true;
      },
      removeBankUcet () {
        this.removing = true;
        window.api.delete("uzivatel/bankovni-ucty/" + this.removeBankUcetItem.id).then((_body) => {
          if (_body.deleted) {
            this.load(() => {
              this.removing = false;
              this.removeBankUcetDialog = false;
            });
          }
          else {
            this.removing = false;
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false;
        });
      },
      passAccept () {
        this.dialogHeslo = false;
      },
      zadostOsobniPoradce () {
        this.savingPoradce = true;
        window.api.post("uzivatel/zadost-osobni-poradce").then((_body) => {
          if (_body.saved) {
            this.load(() => {
              this.savingPoradce = false;
              this.poradceZazadan = true;
            });
          }
          else {
            this.removing = false;
          }
        }).catch((err) => {
          console.log(err);
          this.savingPoradce = false;
        });
      }
    },
    components: {
      HesloDialog
    }
  }
</script>
